export const P2P_DESK_VIEWS = [
  { id: "all", label: "All duels", hint: "Full ledger" },
  { id: "active", label: "Active", hint: "Open duels" },
  { id: "needs_outcome", label: "Needs outcome", hint: "Awaiting settlement" },
  { id: "settled", label: "Settled", hint: "Completed" },
  { id: "voided", label: "Voided", hint: "Cancelled" },
];

export const P2P_STATUS_FILTERS = [
  { value: "All", label: "Any status" },
  { value: "Active", label: "Active" },
  { value: "Pending", label: "Pending" },
  { value: "Settled", label: "Settled" },
  { value: "Voided", label: "Voided" },
];

export const P2P_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "pool", label: "Largest pool" },
  { value: "stake", label: "Highest stake" },
];

export function sortDuels(duels = [], sortKey = "newest") {
  const list = [...duels];
  switch (sortKey) {
    case "oldest":
      return list.sort(
        (a, b) => new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime()
      );
    case "pool":
      return list.sort((a, b) => (Number(b.poolTotal) || 0) - (Number(a.poolTotal) || 0));
    case "stake":
      return list.sort((a, b) => (Number(b.stake) || 0) - (Number(a.stake) || 0));
    default:
      return list.sort(
        (a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime()
      );
  }
}

export function clientFilterDuels(duels = [], search = "") {
  const q = search.trim().toLowerCase();
  if (!q) return duels;
  return duels.filter((duel) => {
    const hay = [
      duel.matchLabel,
      duel.matchHome,
      duel.matchAway,
      duel.fixtureStatus,
      duel.selection,
      duel.creatorName,
      duel.creatorEmail,
      duel.creatorCode,
      duel.status,
      duel.p2pStatus,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}
